export default function WhyVigorbuySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Why Use <span className="text-accent-600">Vigorbuy Spreadsheet</span>?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See how Vigorbuy Spreadsheet transforms your shopping research experience compared to traditional browsing methods.
          </p>
        </div>

        <div className="max-w-3xl mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-4 px-5 text-sm font-heading font-semibold text-foreground-800">Feature</th>
                <th className="text-left py-4 px-5 text-sm font-heading font-semibold text-foreground-500">Normal Searching</th>
                <th className="text-left py-4 px-5 text-sm font-heading font-semibold text-primary-700">Vigorbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', normal: 'Slow — browse one page at a time', vigorbuy: 'Fast — view dozens of products at once' },
                { feature: 'Organization', normal: 'Low — scattered across multiple tabs', vigorbuy: 'High — everything in one organized view' },
                { feature: 'Categories', normal: 'Limited — hard to find related items', vigorbuy: 'Complete — browse by 14+ curated categories' },
                { feature: 'Research Time', normal: 'Long — endless scrolling and searching', vigorbuy: 'Reduced — efficient spreadsheet-style browsing' },
                { feature: 'Comparison', normal: 'Difficult — manually compare across tabs', vigorbuy: 'Easy — side-by-side product data view' },
                { feature: 'Updates', normal: 'Inconsistent — information may be outdated', vigorbuy: 'Regular — frequently updated product data' },
              ].map((row) => (
                <tr key={row.feature} className="border-b border-background-200 hover:bg-background-50 transition-colors">
                  <td className="py-3.5 px-5 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-3.5 px-5 text-sm text-foreground-500">{row.normal}</td>
                  <td className="py-3.5 px-5 text-sm text-primary-700 font-medium">{row.vigorbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}